import Vue from 'vue'
import VueRouter from 'vue-router'
import NProgress from 'nprogress'
import store from './plugins/store'
import axios from "./plugins/axios"

import Home from "./components/Home"
import AcceptCgu from "./components/configuration/AcceptCgu"
import Campaigns from "./components/campaign/Campaigns"
import Prestataire from "./components/provider/Provider"
import Webform from "./components/webform/Webform"
import Onboard from "./components/onboard/Onboard"
import Configuration from "./components/configuration/Configuration"
import CreateCmajCampaign from "./components/campaign/cmaj/CreateCampaign"
import EmailValidation from "./components/configuration/EmailValidation"
import Answer from "./components/webform/Answer"
import CmajRevival from "./components/campaign/cmaj/CmajRevival"
import CadhRevival from "./components/campaign/cadh/CadhRevival"
import CmajProviderCampaign from "./components/campaign/cmaj/ProviderCampaign"
import CadhProviderCampaign from "./components/campaign/cadh/ProviderCampaign"
import BusinessConfig from "./components/configuration/pages/BusinessConfig"
import TeamConfig from "./components/configuration/pages/TeamConfig"
import SenderConfig from "./components/configuration/pages/SenderConfig"
import ReferentialConfig from "./components/configuration/pages/ReferentialConfig"
import ContractConfig from "./components/configuration/pages/ContractConfig"
import CreateCmajCampaignScratch from "@/components/campaign/cmaj/CreateCampaignScratch"
import FormConfig from "./components/configuration/pages/FormConfig"
import Preview from "@/components/webform/Preview"
import CreateCadhCampaign from "./components/campaign/cadh/CreateCampaign"
import CreateCadhCampaignScratch from "./components/campaign/cadh/CreateCampaignScratch"
import Login from "@/components/Login"
import AuraForm from "@/components/aura/AuraForm"
import AuraProvider from "./components/aura/AuraProvider"
import AuraAnswer from "@/components/aura/AuraAnswer"
import TagConfig from "./components/configuration/pages/TagConfig"
import ForgetPassword from "@/components/ForgetPassword"
import ResetPassword from "@/components/ResetPassword"
import DuplicateCampaign from "@/components/campaign/cmaj/DuplicateCampaign"
import ProLayout from "./components/pro/ProLayout"
import UpdateCampaign from "./components/campaign/cmaj/UpdateCampaign"
import UpdateCadhCampaign from "./components/campaign/cadh/UpdateCampaign"
import EmailTemplateConfig from "./components/configuration/pages/EmailTemplateConfig"
import CreateProvider from "./components/provider/create-provider/CreateProvider"
import ApidaeProject from "./components/configuration/pages/ApidaeProject"
import UnlogedAnswer from "./components/webform/UnlogedAnswer"
import WebFormTemplateConfig from "./components/configuration/pages/WebFormTemplateConfig"
import DasboardStat from "./components/stats/DasboardStat"
import ProviderStat from "./components/stats/ProviderStat"
import OpenForm from "./components/pro/CMAJ/OpenForm"
import AdhesionAnswer from "./components/campaign/cadh/AdhesionAnswer"
import CmajStat from "./components/stats/CmajStat"
import CadhPreview from "./components/campaign/cadh/CadhPreview"
import Result from "./components/tools/Result"
import Management from "./components/connexion/Management"
import CampaignConfig from "./components/campaign/cmaj/CampaignConfig"
import CadhCampaignConfig from "./components/campaign/cadh/CampaignConfig"
import UskaNotificationConfig from "./components/configuration/pages/UskaNotificationConfig.vue"
import UskaProConfig from "./components/configuration/pages/UskaProConfig.vue"
import InvoiceConfig from "./components/configuration/pages/InvoiceConfig.vue"
import CadhConfig from "./components/configuration/pages/CadhConfig.vue"
import WhitePage from "./components/veilleTourisme/WhitePage.vue"
import CadhManagement from "./components/configuration/pages/CadhManagement.vue"
import CadhConfigEdit from "./components/cadhConfiguration/CadhConfigEdit.vue"
import SitAnswer from "./components/webform/SitAnswer.vue"
import SitForm from "./components/pro/CMAJ/Sit/SitForm.vue"
import VtCampaign from "./components/veilleTourisme/VtCampaign.vue"
import VtcConfig from "./components/configuration/pages/VtcConfig.vue"
import VtcAddProviders from "./components/veilleTourisme/VtcAddProviders.vue"
import ApidaeConfig from "./components/configuration/pages/ApidaeConfig.vue"
import Entities from "./components/entities/Entities.vue"
import Entity from "./components/entities/Entity.vue"
import Maintenance from "./components/Maintenance.vue"
import RedirectPayfipPayment from "./components/RedirectPayfipPayment.vue"
import PayfipRedirectionAfterPayment from "./components/PayfipRedirectionAfterPayment.vue"

Vue.use(VueRouter)
Vue.component('router-link', Vue.options.components.RouterLink)
Vue.component('router-view', Vue.options.components.RouterView)

const router = new VueRouter({
    mode: 'history',
    routes: [
        { path: '/',                                    component: Home },
        { path: '/login',                               component: Login,                     meta: {                                           title: 'Connexion' } },
        { path: '/forget-password',                     component: ForgetPassword,            meta: {                                           title: 'Mot de passe oublié' } },
        { path: '/reset-password/:token',               component: ResetPassword,             meta: {                                           title: 'Réinitialisation du mot de passe' } },
        { path: '/home',                                component: () => import(/* webpackChunkName: "home-page" */ "./components/HomePage"), meta: { requiresAuth: true, title: 'Accueil' } },
        { path: '/accept-cgu',                          component: AcceptCgu,                 meta: { requiresAuth: true,                       title: 'Cgu' } },
        { path: '/email-validation',                    component: EmailValidation },
        { path: '/onboard',                             component: Onboard,                   meta: { requiresAuth: true } },
        { path: '/campaign/cmaj/create',                component: CreateCmajCampaign,        meta: { requiresAuth: true, acceptCgu: true,      title: 'Campagne' } },
        { path: '/campaign/cmaj/create-scratch',        component: CreateCmajCampaignScratch, meta: { requiresAuth: true, acceptCgu: true,      title: 'Campagne' },                       name: 'cmaj-scratch' },
        { path: '/campaign/casp/create-scratch/:aspect',component: CreateCmajCampaignScratch, meta: { requiresAuth: true, acceptCgu: true,      title: 'Campagne' },                       name: 'cmaj-scratch' },
        { path: '/campaign/cmaj/duplicate/:hash',       component: DuplicateCampaign,         meta: { requiresAuth: true, acceptCgu: true,      title: 'Campagne' } },
        { path: '/campaign/cmaj/:aspect/duplicate/:hash',       component: DuplicateCampaign,         meta: { requiresAuth: true, acceptCgu: true,      title: 'Campagne' } },
        { path: '/campaign/cadh/create',                component: CreateCadhCampaign,        meta: { requiresAuth: true, acceptCgu: true,      title: 'Campagne' } },
        { path: '/campaign/cadh/create-scratch',        component: CreateCadhCampaignScratch, meta: { requiresAuth: true, acceptCgu: true,      title: 'Campagne' },                       name: 'cadh-scratch'},
        { path: '/campaign/cmaj/:hash',                 component: CmajProviderCampaign,      meta: { requiresAuth: true, acceptCgu: true } },
        { path: '/campaign/cmaj/config/:hash',          component: CampaignConfig,            meta: { requiresAuth: true, acceptCgu: true } },
        { path: '/campaign/cadh/config/:hash',          component: CadhCampaignConfig,        meta: { requiresAuth: true, acceptCgu: true } },
        { path: '/campaign/cadh/:hash',                 component: CadhProviderCampaign,      meta: { requiresAuth: true, acceptCgu: true } },
        { path: '/revival/cmaj/:hash',                  component: CmajRevival,               meta: { requiresAuth: true, acceptCgu: true,      title: 'Relance campagne' } },
        { path: '/revival/cmaj/update/:hash',           component: CmajRevival,               meta: { requiresAuth: true, acceptCgu: true,      title: 'Relance campagne' } },
        { path: '/revival/cadh/:hash',                  component: CadhRevival,               meta: { requiresAuth: true, acceptCgu: true,      title: 'Relance campagne' } },
        { path: '/revival/cadh/update/:hash',           component: CadhRevival,               meta: { requiresAuth: true, acceptCgu: true,      title: 'Relance campagne' } },
        { path: '/update-campaign/cmaj/:hash',          component: UpdateCampaign,            meta: { requiresAuth: true, acceptCgu: true,      title: 'Campagne' } },
        { path: '/update-campaign/cadh/:hash',          component: UpdateCadhCampaign,        meta: { requiresAuth: true, acceptCgu: true,      title: 'Campagne' } },
        { path: '/campaigns',                           component: Campaigns,                 meta: { requiresAuth: true, acceptCgu: true,      title: 'Campagnes' } },
        { path: '/providers',                           component: Prestataire,               meta: { requiresAuth: true, acceptCgu: true,      title: 'Prestataires' } },
        { path: '/configuration',                       component: Configuration,             meta: { requiresAuth: true,                       title: 'Configuration' } },
        { path: '/configuration/business',              component: BusinessConfig,            meta: { requiresAuth: true,                       title: 'Configuration - Structure' } },
        { path: '/configuration/team',                  component: TeamConfig,                meta: { requiresAuth: true,                       title: 'Configuration - Equipe' } },
        { path: '/configuration/senders',               component: SenderConfig,              meta: { requiresAuth: true,                       title: 'Configuration - Boîtes d\'envois' } },
        { path: '/configuration/referential',           component: ReferentialConfig,         meta: { requiresAuth: true,                       title: 'Configuration - Référentiel' } },
        { path: '/configuration/contracts',             component: ContractConfig,            meta: { requiresAuth: true,                       title: 'Configuration - Contrats' } },
        { path: '/configuration/forms',                 component: FormConfig,                meta: { requiresAuth: true,                       title: 'Configuration - Formulaires' } },
        { path: '/configuration/tags',                  component: TagConfig,                 meta: { requiresAuth: true,                       title: 'Configuration - Tags' } },
        { path: '/configuration/email-template',        component: EmailTemplateConfig,       meta: { requiresAuth: true,                       title: 'Configuration - Modèles emails' } },
        { path: '/configuration/form-template',         component: WebFormTemplateConfig,     meta: { requiresAuth: true,                       title: 'Configuration - Modèles de formulaires' } },
        { path: '/configuration/apidae-projects',       component: ApidaeProject,             meta: { requiresAuth: true,                       title: 'Configuration - Projets Apidae' } },
        { path: '/configuration/apidae-configuration',  component: ApidaeConfig,              meta: { requiresAuth: true,                       title: 'Configuration - Configuration Apidae' } },
        { path: '/dashboard-stat/',                     component: DasboardStat,              meta: { requiresAuth: true,                       title: 'Statistiques - Dashboard' } },
        { path: '/dashboard-stat/fiches',               component: ProviderStat,              meta: { requiresAuth: true,                       title: 'Statistiques - Fiches' } },
        { path: '/dashboard-stat/campagnes',            component: CmajStat,                  meta: { requiresAuth: true,                       title: 'Statistiques - Campagnes' } },
        { path: '/create-provider',                     component: CreateProvider,            meta: { requiresAuth: true,                       title: 'Création de fiche' } },
        { path: '/web-form/:token/:name',               component: Webform },
        { path: '/espace-pro/formulaire/:providerId',   component: OpenForm },
        { path: '/sit/formulaire/:providerId',          component: SitForm },
        { path: '/espace-pro/:token/*',                 component: ProLayout,
            beforeEnter: async (to, from, next) => {
            console.log('to',to)
                console.log('from', from)
                const shouldRedirect = process.env.NODE_ENV !== 'development' && to.query.no_redirection !== 'true'
                if (shouldRedirect) {
                    try {
                        const response = await axios.get(`/professional/uska-account-url/${to.params.token}`)
                        if(response.body.data.url !== null) {
                            window.location.replace(response.body.data.url)
                        } else {
                            next()
                        }
                    } catch (e) {
                        let url = process.env.VUE_APP_USKA_FRONT_URL + 'mes-echanges'
                        window.location.replace(url)
                    }
                } else {
                    next()
                }
            }},
        { path: '/aura/:token',                         component: AuraForm },
        { path: '/receptive/answer/:token',             component: AuraAnswer,                meta: { requiresAuth: true, acceptCgu: true } },
        { path: '/receptive-providers',                 component: AuraProvider,              meta: { requiresAuth: true, acceptCgu: true,      title: 'Prestataires' } },
        { path: '/preview/*',                   component: Preview,                   meta: { requiresAuth: true, acceptCgu: true,      title: 'Prévisualisation' } },
        { path: '/cadh-preview/:token',              component: CadhPreview,               meta: { title: 'Prévisualisation' } },
        { path: '/answer/:token',                       component: Answer,                    meta: { requiresAuth: true, acceptCgu: true } },
        { path: '/sit-answer/:token',                   component: SitAnswer,                 meta: { requiresAuth: true, acceptCgu: true } },
        { path: '/adhesion/answer/:answerId',           component: AdhesionAnswer,            meta: { requiresAuth: true, acceptCgu: true } },
        { path: '/simple-answer/:token',                component: UnlogedAnswer },
        { path: '/summary/:hash',                       component: () => import(/* webpackChunkName: "summary" */ "./components/provider/summary/Summary"), meta: { requiresAuth: true, acceptCgu: true } },
        { path: '/adhesion-result',                     component: Result },
        { path: '/connexions',                          component: Management, title: 'Connexions' },
        { path: '/configuration/adhesion-config',       component: CadhConfig,                meta: { requiresAuth: true,                       title: 'Configuration - Configuration formulaire d\'adhésion' } },
        { path: '/configuration/invoice-config',        component: InvoiceConfig,             meta: { requiresAuth: true,                       title: 'Configuration - Configuration outil de génération de factures' } },
        { path: '/configuration/uska-notifications',    component: UskaNotificationConfig,    meta: { requiresAuth: true,                       title: 'Configuration - Notifications Uska' } },
        { path: '/configuration/uska-pro-config',    component: UskaProConfig,    meta: { requiresAuth: true,                       title: 'Configuration - Espace pro Uska' } },
        { path: '/vtc-diffs/approve/:vtcDiffId', component: WhitePage},
        { path: '/vtc-diffs/denial/:vtcDiffId', component: WhitePage},
        { path: '/vtc-diffs/unsubscribed/:vtcDiffId', component: WhitePage},
        { path: '/configuration/adhesion-management',       component: CadhManagement,                meta: { requiresAuth: true,                       title: 'Configuration - Mes bulletins d\'adhésion' } },
        { path: '/configuration/adhesion-management/edit/:configId',       component: CadhConfigEdit,                meta: { requiresAuth: true,                       title: 'Configuration - Mes bulletins d\'adhésion - Edition' } },
        { path: '/veille/vtc', component: VtCampaign, meta: { requiresAuth: true, acceptCgu: true, title: 'Veille Tourisme' } },
        { path: '/veille/vtc/import-in-progress', component: VtCampaign, meta: { requiresAuth: true, acceptCgu: true, title: 'Veille Tourisme' } },
        { path: '/configuration/veille', component: VtcConfig, meta: { requiresAuth: true, title: 'Configuration - Veille' }},
        { path: '/veille/vtc/add-providers', component: VtcAddProviders, meta: { requiresAuth: true, acceptCgu: true, title: 'Veille Tourisme - Ajout de prestataires' } },
        { path: '/entities', component: Entities, meta: { requiresAuth: true, title: 'Entités' }},
        { path: '/entity/:hash',      component: Entity,    meta: { requiresAuth: true, acceptCgu: true } },
        { path: '/redirect-payment/:cadhAnswerId', component: RedirectPayfipPayment },
        { path: '/redirect-after-payment/:cadhAnswerId?', component: PayfipRedirectionAfterPayment },
        { path: '/:token',                              component: Home },
        {
            path: '/maintenance',
            name: 'maintenance',
           component: Maintenance,
        }
    ]
})

router.beforeEach((to, from, next) => {
    NProgress.start()

    let isInMaintenance = store.state.global.maintenance

    // Priorité absolue : si on est en maintenance, on bloque tout sauf la page maintenance elle-même
    if (isInMaintenance && to.name !== 'maintenance') {
        next({ name: 'maintenance' })
        return
    }

    // Si la maintenance est levée mais qu'on est encore sur /maintenance, on retourne à l'accueil
    if (!isInMaintenance && to.name === 'maintenance') {
        next({ path: '/' })
        return
    }

    loadCredentials(to).then(async () => {
        Vue.prototype.$global.$emit('hide-msg')

        if (to.meta.title !== undefined) {
            document.title = 'Uska – ' + to.meta.title
        } else {
            document.title = 'Uska'
        }

        let user = store.getters['account/user']

        let query = to.query

        if (query.token !== undefined && user) {
            store.commit('account/setUser', null)
            store.commit('account/setToken', null)
            user = null
        }

        if (query.token !== undefined && to.path !== '/') {
            next({ path: '/', query: query })
        } else if (to.meta.requiresGod && user.role.name !== 'GOD') {
            next({ path: '/' })
        } else if (to.meta.requiresAuth && (user === undefined || user === null)) {
            next({ path: '/' })
        } else if (to.meta.acceptCgu && user !== undefined && user !== null && !user.cgu_validation) {
            next({ path: '/accept-cgu' })
        } else if (to.path === '/'
          && user !== undefined
          && user !== null
        ) {
            next({ path: '/home' })
        } else {
            next()
        }
    })
})

router.afterEach(() => {
    NProgress.done()
})

async function loadCredentials (to) {
    if(to.meta !== undefined && to.meta.requiresAuth) {
        await store.dispatch('account/getCredentials')
    }
}

export default router
